/**
 * Parse a currency string like "Rs. 1,234.56" into a number
 * @param {string|number} value
 * @returns {number}
 */
export function parseCurrency(value) {
    if (typeof value === "number") return value;

    return parseFloat(
        value
            .replace(/Rs\.\s?/, "") // remove "Rs."
            .replace(/,/g, "")      // remove commas
    );
}

/**
 * Format a number into currency string with Rs. prefix
 * @param {number|string} value
 * @returns {string}
 */
export function formatCurrency(value) {
    const num = typeof value === "string" ? parseCurrency(value) : value;
    return "Rs. " + numberWithCommas(num.toFixed(2));
}

/**
 * Add commas to number string (e.g., 1234.56 → 1,234.56)
 * @param {string|number} x
 * @returns {string}
 */
export function numberWithCommas(x) {
    const parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

/**
 * Check weather the Web Site load via React Native WebView
 * @returns {boolen}
 */
export function isReactNativeWebView() {
    return !!window.ReactNativeWebView;
}
